import React, { useState,useEffect, useRef } from "react";
import { isHTML } from "../../../../../utils/helpers";
import { blockDateFromAppointmentCancellation } from "../../../../../services/medium";
const generateSrcDoc = (htmlBody) => `
  <html>
    <head>
    <link rel="stylesheet" href="/fonts/style.css" />
       <style>
        body {
          margin-left: 10;
          font-family: "Oakes-Grotesk-Medium";
          font-size : 14px;
          color: #555;
        }
      </style>
    </head>
    <body>
      ${htmlBody}
      <script>
        function sendHeight() {
          const height = document.body.scrollHeight;
          parent.postMessage({ type: 'setHeight', height }, '*');
        }
        window.onload = sendHeight;
        window.onresize = sendHeight;
      </script>
    </body>
  </html>
`;
export default function ConfirmCancelNotePopup({ deleteUser,cancelRequest, id, payment_status="" , cancellation_policy="", active ="" }) {
  const iframeRef = useRef(null);
      const [iframeHeight, setIframeHeight] = useState("100px");
      useEffect(() => {
              const handleMessage = (event) => {
                  if (event.data && event.data.type === "setHeight") {
                      let height =  event.data.height + 65;
                  setIframeHeight(height + "px");
                  }
              };
      
              window.addEventListener("message", handleMessage);
              return () => window.removeEventListener("message", handleMessage);
              }, []);
    const getInfo = (info) => {

        const rawContentFromDB = info
        let html;
        if (!isHTML(rawContentFromDB)) {
            console.log( info,"ckejdnm1")
            let info =
                rawContentFromDB
                    .split("\n")
                    .map(line => `${line}`)
                    .join("");
            console.log(info, "cejdncjkm");
            html = info
            return info
        }
        else {
           // console.log( info,"ckejdnm2anuj")
            // html = JSON.parse(rawContentFromDB).content
            // return <div dangerouslySetInnerHTML={{ __html: rawContentFromDB }} />
            
              html = JSON.parse(rawContentFromDB).content
              const srcDoc = generateSrcDoc(html);
            return srcDoc 
        }

// "{\"content\":\"<p style=\\\"margin-left:0px;\\\">Try a Community Support Group:</p>\\n<ol>\\n<li><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Male Mediums - Ed S. Mediums Who Speak French - Cindy L.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unsupported: Doubt/Fear from Family/Friends = Lisa A.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unity: Group Meditation - Amber K. Healing Session for Mediums - Catherine B.</span></li>\\n</ol>\\n\"}"

    }
    const block = (blockType) => () => {
       deleteUser();
      if(active == null || active == undefined || active == ""){
    return;
      }
      let {
        e,
        type,
        targetTypeID,
        sessionType,
        noShowBy,
        appoinment
      } = active;
      if(blockType != null){
        console.log(blockType,"BLOCKTYPE", appoinment);
        let body = {
          medium_id: appoinment.medium_id,
          date: appoinment.date,
          time: appoinment.time,
          type: blockType
        }
        blockDateFromAppointmentCancellation(body).then((res)=>{
          console.log(res,"success");
        }).catch((err)=>{
          console.log(err,"errors");
        })
      }
     //blockDateFromAppointmentCancellation
      }
    // This effect runs when the component mounts or when the id changes
  return (
    <div className="confirm-delete-wrapper cancelation-popup-show register-medium">
      <div data-backdrop="static" className="modal fade" id={id} role="dialog">
        <div className="modal-dialog padding-unset modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
               <div
            className="modal-close-icon"
            data-dismiss="modal"
            onClick={cancelRequest}
            style={{
              position: "absolute",
              top: "10px",
              right: "15px",
              fontSize: "22px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            x
          </div>
              <div className="icon-pop">
                <img src="images/Union-icon.png" alt="Union-icon" />
              </div>
              <p>Should we block this time in your schedules for you?</p>
              <div className="confirm-btn-box cancelation-popup-box">
                <div
                  className="register-medium-confirnation model-close-btn"
                  onClick={deleteUser}
                  data-dismiss="modal"
                >
                  No
                </div>
                <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={block("full_day")}
                >
                  Block Full Day
                </div>
                 <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={block("one_hour")}
                >
                  Block 1 Hour
                </div>
            
                
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
